export default __webpack_public_path__ + "static/media/PlayStore.76c87fa4.png";